import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=75f5ffac&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=75f5ffac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75f5ffac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('75f5ffac')) {
      api.createRecord('75f5ffac', component.options)
    } else {
      api.reload('75f5ffac', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=75f5ffac&scoped=true&", function () {
      api.rerender('75f5ffac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2s17uMpxCTk5Z/JS/comp/PopupBox.vue"
export default component.exports